import React from 'react';
import { DialogActions, Button, CircularProgress } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

interface DialogActionButtonsProps {
    isLoading: boolean;
    isFormValid: boolean;
    onCancel: () => void;
    onSave: () => void;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
    isLoading,
    isFormValid,
    onCancel,
    onSave
}) => {
    return (
        <DialogActions sx={{ p: 3, pt: 2 }}>
            <Button
                onClick={onCancel}
                disabled={isLoading}
                sx={{ mr: 1 }}
            >
                Cancel
            </Button>
            <Button
                variant="contained"
                onClick={onSave}
                disabled={isLoading || !isFormValid}
                startIcon={isLoading ? <CircularProgress size={20} /> : <AddIcon />}
                sx={{
                    backgroundColor: '#162346',
                    '&:hover': {
                        backgroundColor: '#1a2a52'
                    }
                }}
            >
                {isLoading ? 'Creating...' : 'Create Contract'}
            </Button>
        </DialogActions>
    );
};
